export default __webpack_public_path__ + "static/LeituraTwo-RomanItalic-c89f9d8723ca95880fba8d31d1292d0b.woff";